import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  followMouse: true,
};

const followMouseSlice = createSlice({
  name: "followMouse",
  initialState,
  reducers: {
    setFollowMouse: (state, action) => {
      state.followMouse = action.payload;
    },
  },
});

export const { setFollowMouse } = followMouseSlice.actions;
export default followMouseSlice.reducer;
